(function(){
  var B = window.MonnBF; if(!B) return;
  /* ---------- time & weeks ---------- */
  function now(){
    if(B.preview){ try{ var q = new URLSearchParams(location.search).get('bfdate'); if(q){ var t = Date.parse(q); if(!isNaN(t)) return t; } }catch(e){} }
    return Date.now();
  }
  B.now = now;
  B.state = function(){ var t = now(); return t < Date.parse(B.eventStart) ? 'soon' : (t > Date.parse(B.eventEnd) ? 'ended' : 'live'); };
  B.wave = function(){
    var t = now(), w = 0;
    B.waves.forEach(function(x, i){ if(t >= Date.parse(x.start) && t <= Date.parse(x.end)) w = i; });
    return w;
  };
  B.deals = function(i){
    var out = {}; var w = B.waves[i]; if(!w || !w.deals) return out;
    w.deals.split(',').forEach(function(d){ var p = d.trim().split(':'); if(p[0]) out[p[0]] = {off: (+p[1]||0) * 100, limit: +p[2]||0}; });
    return out;
  };
  B.dealFor = function(handle){
    if(B.state() !== 'live' || !(B.dealsReady || B.preview)) return null;
    var i = B.wave(), d = B.deals(i)[handle];
    if(!d) return null; d.wave = i; d.end = B.waves[i].dealEnd; return d;
  };
  /* show the November price: in preview, and on the live site while the scheduled discounts run */
  B.useNov = function(){ return !!(B.preview || (B.byDiscount && B.state() === 'live')); };
  B.money = function(c){
    var d = c / 100, s = (d % 1 === 0) ? d.toLocaleString('en-US') : d.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    return '$' + s;
  };
  B.left = function(ms){
    var s = Math.max(0, Math.floor(ms / 1000)), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
    function p(n){ return (n < 10 ? '0' : '') + n; }
    return d > 0 ? d + 'd ' + p(h) + 'h ' + p(m) + 'm' : p(h) + ':' + p(m) + ':' + p(sec);
  };
  B.day = function(iso){ var t = new Date(Date.parse(iso)); return t.toLocaleDateString('en-US', {weekday: 'short', month: 'numeric', day: 'numeric', timeZone: 'America/Chicago'}).replace(',', ''); };
  B.track = function(where){
    try{ if(window.fbq) fbq('trackCustom', 'BFClick', {where: where}); }catch(e){}
    try{ if(window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('monn_bf_click', {where: where}); }catch(e){}
  };
  document.addEventListener('click', function(e){ var a = e.target.closest('[data-bf-click]'); if(a) B.track(a.getAttribute('data-bf-click')); });

  /* ---------- countdowns: every [data-bf-count] on the page ---------- */
  function tick(){
    var st = B.state(), t = now(), i = B.wave(), w = B.waves[i];
    document.querySelectorAll('[data-bf-wave-label]').forEach(function(el){
      var lt = st === 'soon' ? 'All November · starts ' + B.day(B.eventStart) : 'Week ' + (i + 1) + ' · ' + w.name;
      if(el.textContent !== lt) el.textContent = lt;
    });
    document.querySelectorAll('[data-bf-count]').forEach(function(el){
      var kind = el.getAttribute('data-bf-count-kind');
      if(st === 'soon'){ el.innerHTML = 'Starts in <b>' + B.left(Date.parse(B.eventStart) - t) + '</b>'; return; }
      if(st === 'ended'){ el.textContent = 'Black Friday has ended'; return; }
      var hasDeals = (B.dealsReady || B.preview) && w.deals;
      var end = Date.parse(hasDeals ? w.dealEnd : B.eventEnd);
      var label = hasDeals ? (i === 4 ? 'Doorbusters end in ' : (i === 3 ? 'Doorbusters end in ' : 'Deal of the Week ends in ')) : 'Black Friday prices end in ';
      if(kind === 'event'){ end = Date.parse(B.eventEnd); label = 'Black Friday prices end in '; }
      el.innerHTML = label + '<b>' + B.left(end - t) + '</b>';
    });
  }
  B.tick = tick;
  tick(); setInterval(tick, 1000);

  /* ---------- legacy product cards (collections, related products, cart suggestions) ---------- */
  function handleOf(card){ var a = card.querySelector('a[href*="/products/"]'); if(!a) return null; var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/); return m ? m[1] : null; }
  function cents(txt){ var n = (txt || '').replace(/[^0-9.]/g, ''); return n ? Math.round(parseFloat(n) * 100) : 0; }
  B.decorateCards = function(scope){
    (scope || document).querySelectorAll('article.card:not([data-bf-done])').forEach(function(card){
      card.setAttribute('data-bf-done', '1');
      var h = handleOf(card), pl = card.querySelector('.priceline'); if(!h || !pl) return;
      var b = pl.querySelector('b'); if(!b) return;
      var shown = cents(b.textContent), ref = B.prices[h] || [0, 0], was = ref[0], nov = ref[1], disp = shown, pv = false;
      if(B.useNov() && nov && nov < shown){ disp = nov; pv = !!B.preview; }
      var native = pl.querySelector('s'); if(native) native.remove();
      var badge = card.querySelector('.shot .badge');
      if(was > disp){
        pl.innerHTML = '<span class="bfp is-sale">' + (pv ? '<span class="bfp-pv">Preview price</span>' : '') + '<b class="bfp-now">' + B.money(disp) + '</b><s class="bfp-was"><span class="bf-vh">Regular price </span>' + B.money(was) + '</s><span class="bfp-save">Save ' + B.money(was - disp) + '</span></span>';
        if(badge){ badge.textContent = 'Black Friday'; badge.classList.add('bf-badge'); }
        else { var shot = card.querySelector('.shot'); if(shot){ var sp = document.createElement('span'); sp.className = 'badge bf-badge'; sp.textContent = 'Black Friday'; shot.prepend(sp); } }
      } else if(badge && /sale/i.test(badge.textContent)){ badge.remove(); }
      var d = B.dealFor(h);
      if(d){ var t = document.createElement('div'); t.className = 'bf-deal-line'; t.style.cssText = 'margin-top:.35rem';
        t.innerHTML = '<span class="bf-deal-tag">' + (d.wave >= 3 ? 'Doorbuster' : 'Deal of the Week') + ' · ' + B.money(Math.max(0, disp - d.off)) + ' in cart</span>'; pl.after(t); }
    });
  };
  /* deal slots inside Black Friday cards and deal cards */
  B.fillDeals = function(){
    document.querySelectorAll('[data-bf-deal-slot]').forEach(function(slot){
      var h = slot.getAttribute('data-handle'), d = B.dealFor(h), key = d ? d.wave + ':' + d.off : 'none';
      if(slot.getAttribute('data-bf-key') === key) return;
      slot.setAttribute('data-bf-key', key);
      if(!d){ slot.innerHTML = ''; slot.hidden = true; return; }
      var nowc = +slot.getAttribute('data-now') || 0, label = d.wave >= 3 ? 'Doorbuster' : 'Deal of the Week';
      slot.hidden = false;
      slot.innerHTML = '<span class="bf-deal-tag">' + label + ' · ' + B.money(Math.max(0, nowc - d.off)) + ' in cart</span>' +
        '<small class="bf-deal-note">Extra ' + B.money(d.off) + ' off · ends ' + B.day(d.end) + (d.limit ? ' · limited to ' + d.limit : '') + (B.preview && !B.dealsReady ? ' · <span class="bfp-pv">Preview</span>' : '') + '</small>';
    });
    document.querySelectorAll('[data-bf-deal-card]').forEach(function(c){ c.hidden = !B.dealFor(c.getAttribute('data-handle')); });
  };
  function runCards(){ if(B.state() !== 'ended'){ B.decorateCards(); B.fillDeals(); } }
  setInterval(function(){ B.fillDeals(); }, 30000);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runCards); else runCards();
  var pend = false;
  if('MutationObserver' in window){ new MutationObserver(function(muts){
    if(pend) return;
    for(var k = 0; k < muts.length; k++){ var n = muts[k].target; if(n && n.closest && n.closest('[data-bf-count]')) continue; pend = true; break; }
    if(pend) setTimeout(function(){ pend = false; runCards(); }, 150);
  }).observe(document.body || document.documentElement, {childList: true, subtree: true}); }

  /* ---------- truck pop-up ---------- */
  var tr = document.getElementById('bf-truck');
  if(tr){
    var key = 'monn_bf_truck_seen', force = false, timer = null;
    try{ force = B.preview && new URLSearchParams(location.search).get('bftruck') === '1'; }catch(e){}
    function seen(){ try{ return sessionStorage.getItem(key) === '1'; }catch(e){ return false; } }
    function mark(){ try{ sessionStorage.setItem(key, '1'); }catch(e){} }
    function close(){
      tr.classList.remove('show'); clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      setTimeout(function(){ tr.hidden = true; tr.classList.remove('play'); }, 500);
    }
    function onScroll(){ if((window.scrollY || 0) > 500) close(); }
    function show(){
      if(document.documentElement.classList.contains('mo-lock')) return;
      mark(); tr.hidden = false;
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ tr.classList.add('show', 'play'); }); });
      timer = setTimeout(close, 11000);
      window.addEventListener('scroll', onScroll, {passive: true});
    }
    tr.querySelector('[data-bf-truck-close]').addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !tr.hidden) close(); });
    if('MutationObserver' in window){ new MutationObserver(function(){ if(document.documentElement.classList.contains('mo-lock') && !tr.hidden) close(); }).observe(document.documentElement, {attributes: true, attributeFilter: ['class']}); }
    if(B.state() !== 'ended' && (force || (!seen() && !B.designMode))) setTimeout(show, B.truckDelay || 2000);
    document.addEventListener('shopify:section:select', function(e){ if(e.detail && e.detail.sectionId === B.sectionId) show(); });
  }
})();